/** Presentation-only weather: ~30% of in-game days are rainy. Deterministic per
 *  day (hash of the day number) so every view — interiors, sky band, music rain
 *  layer — agrees without touching the sim or saves. */
import { dayOf } from '@sim/config';

export function isRainy(t: number): boolean {
  const day = dayOf(t);
  const h = (Math.imul(day + 11, 2654435761) >>> 0) % 100;
  return h < 30;
}
